import { Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from '../lib/session';
import { EnrollTwoFactor, SetPassword, SignIn, VerifyTwoFactor } from '../components/Auth';
import { Loading } from '../components/ui';
import { AdminLayout, type StaffUser } from './Layout';
import { CustomerList } from './Clients';
import { CustomerDetail } from './ClientDetail';
import { ProjectDetail } from './ProjectDetail';

const BASE = '/api/admin';

export function AdminApp() {
  const session = useSession<StaffUser>(BASE);
  if (window.location.pathname === '/admin/reset') {
    return <SetPassword base={BASE} endpoint="reset" title="Choose a new password" blurb="Enter a new password for your WebForGrowth owner login." onDone={session.refresh} />;
  }
  if (session.status === 'loading') return <Loading />;
  if (session.status === 'anonymous') return <SignIn base={BASE} panelName="WebForGrowth owner" onDone={session.refresh} />;
  if (session.status === 'pending') {
    return session.pending === 'enroll_2fa'
      ? <EnrollTwoFactor base={BASE} panelName="WebForGrowth owner" required onDone={session.refresh} />
      : <VerifyTwoFactor base={BASE} panelName="WebForGrowth owner" onDone={session.refresh} />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout user={session.user!} billingMode={session.environment?.billingMode} onSignOut={session.signOut} />}>
        <Route path="/admin" element={<Navigate to="/admin/customers" replace />} />
        <Route path="/admin/customers" element={<CustomerList />} />
        <Route path="/admin/customers/:id" element={<CustomerDetail />} />
        <Route path="/admin/projects/:id" element={<ProjectDetail />} />
        <Route path="*" element={<Navigate to="/admin/customers" replace />} />
      </Route>
    </Routes>
  );
}
